import { useState, useEffect } from "react";

import { type Place } from "@xapp/components";

export const usePlaceDetails = (placeId: string | null): [Place, boolean, string] => {
    const [placeDetails, setPlaceDetails] = useState<Place | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!placeId) {
            return;
        }

        const fetchPlaceDetails = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await fetch(`https://places.xapp.ai/maps/api/place/details/json?place_id=${placeId}`);

                const data = await response.json();

                if (data.status === "OK") {
                    // translate the result of the place details to our Place

                    console.log(data.result);

                    // change the address components from long_name to longName
                    const addressComponents = data.result.address_components.map((component: any) => {
                        return {
                            longName: component.long_name,
                            shortName: component.short_name,
                            types: component.types,
                        };
                    });

                    const reviews = data.result.reviews.map((review: any) => {
                        return {
                            authorName: review.author_name,
                            authorUrl: review.author_url,
                            profilePhotoUrl: review.profile_photo_url,
                            rating: review.rating,
                            text: review.text,
                        };
                    });

                    const photos = data.result.photos.map((photo: any) => {
                        return {
                            height: photo.height,
                            width: photo.width,
                            photoReference: photo.photo_reference,
                        };
                    });

                    const place: Place = {
                        name: data.result.name,
                        placeId: data.result.place_id,
                        mapsUrl: data.result.url,
                        formattedAddress: data.result.formatted_address,
                        website: data.result.website,
                        phone: data.result.formatted_phone_number,
                        addressComponents,
                        rating: data.result.rating,
                        totalRatings: data.result.user_ratings_total,
                        reviews,
                        photos,
                        types: data.result.types,
                    };

                    console.log(place);

                    console.log(JSON.stringify(place));

                    setPlaceDetails(place);
                } else {
                    setError(data.status);
                }
            } catch (err) {
                setError("Failed to fetch place details");
            } finally {
                setLoading(false);
            }
        };

        fetchPlaceDetails();
    }, [placeId]);

    return [placeDetails, loading, error];
};
